/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_BeforeInputs */

const en_gc_guides_before = /** @type {(inputs: Gc_Guides_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you start`)
};

const zh_gc_guides_before = /** @type {(inputs: Gc_Guides_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始之前`)
};

/**
* | output |
* | --- |
* | "Before you start" |
*
* @param {Gc_Guides_BeforeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_before = /** @type {((inputs?: Gc_Guides_BeforeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_BeforeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_before(inputs)
	return zh_gc_guides_before(inputs)
});
export { gc_guides_before as "gc.guides.before" }